export default __webpack_public_path__ + "static/media/lenze_918_1.fa7cbe34.jpg";